var Ribbon_default = {
  "ribbon": "mLNmT",
  "ribbonText": "_1CO-X",
  "imageRibbon": "MXuZA"
};
export {
  Ribbon_default as default
};
//# sourceMappingURL=Ribbon-scss.js.map
